module.exports = __webpack_public_path__ + "img/Group-221.1966e31c.svg";